import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import { LuHandHeart } from "react-icons/lu";
import ClientImg from "../../assets/images/client-img.webp";
import AutoPlayCarousel from "../AutoPlayCarousel";
import "./ClientAreaCall.css";

export default function ClientAreaCall(props) {
  return (
    <div>
      <Container>
        <Row>
          <Col className="client-call-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              <LuHandHeart
                style={{ color: props.iconColor }}
                className="client-call-icon"
              />{" "}
              ÁREA EXCLUSIVA DO CLIENTE
            </h2>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="client-call-third-col">
            <p style={{ color: props.textColor, fontSize: props.textSize }}>
              Já é nosso cliente? Aqui você pode acessar, de maneira fácil e
              ágil, todos os serviços e descontos oferecidos pelo Grupo Krause.
            </p>
            <CustomButton
              className="primary-btn"
              variant="primary"
              href="https://centraldocliente.grupokrause.com.br/login?redirect=/boletos"
              rel="noopener noreferrer"
              target="_blank"
              icon=""
              content="CENTRAL DO CLIENTE"
              backgroundColor={props.btnColor}
              fontFamily="Unageo-Bold"
              fontColor={props.white}
              fontSize={20}
              width={260}
              borderColor={props.btnColor}
              disabled={false}
            />
          </Col>
          <Col
            lg={{ span: 6, order: "first" }}
            className="client-call-second-col"
          >
            <div className="client-call-img-container">
              <img src={ClientImg} alt="Cliente" />
              <div className="client-call-img-overlay" />
            </div>
          </Col>
        </Row>
      </Container>
      {props.autoCarosel ? <AutoPlayCarousel /> : ""}
    </div>
  );
}
